export const REPORT_REASONS = [
  {
    translateToken: 'inappropriate-offensive',
    type: 'InappropriateOffensiveContent',
  },
  {
    translateToken: 'scam-artist',
    type: 'ScamArtist',
  },
  {
    translateToken: 'commercial-posting',
    type: 'CommercialPosting',
  },
  {
    translateToken: 'miscategorized',
    type: 'Miscategorized',

  },
  {
    translateToken: 'other',
    type: 'Other',
  },
] as const;
